import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { I as Icon } from '../Icon/Icon-AcXbY_t4.js';
import { s as spinner } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const LoadingIcon = ({
  ...rest
}) => /*#__PURE__*/React__default.createElement(Icon, _extends({
  type: spinner
}, rest));

export { LoadingIcon as L };
//# sourceMappingURL=LoadingIcon-DySNdZRD.js.map
